// extracted by mini-css-extract-plugin
export var gradientLeft = "LogoMarquee-module--gradientLeft--fad4d";
export var gradientRight = "LogoMarquee-module--gradientRight--a2caf";
export var logoItem = "LogoMarquee-module--logoItem--8ea32";
export var marqueeContainer = "LogoMarquee-module--marqueeContainer--dee60";
export var marqueeContent = "LogoMarquee-module--marqueeContent--41dfc";
export var marqueeContentOffset = "LogoMarquee-module--marqueeContentOffset--9e50a";
export var marqueeRow = "LogoMarquee-module--marqueeRow--07028";
export var marqueeTrack = "LogoMarquee-module--marqueeTrack--47dc2";
export var marqueeWrapper = "LogoMarquee-module--marqueeWrapper--572c6";
export var scroll = "LogoMarquee-module--scroll--df18f";
export var scrollOffset = "LogoMarquee-module--scrollOffset--7aa03";